import { extendTheme } from "@chakra-ui/react";
 
export const theme=extendTheme({
    colors:{
        brandColor:"#2557a7",
        success:"#009688",
        error:"#FFC107",
        warning:"#FF9800",
        ratecompany:"#f5fbf9",
        starColor:"#aa0087"
        
    },
})